import { Dialog, DialogContent, Button, Typography, Box } from '@mui/material'

interface AccountLinkingErrorModalProps {
  isOpen: boolean
  onClose: () => void
  errorMessage: string | null
  userEmail: string
  onLogout: () => void
}

export default function AccountLinkingErrorModal({
  isOpen,
  onClose,
  errorMessage,
  userEmail,
  onLogout,
}: AccountLinkingErrorModalProps) {
  const handleLogout = () => {
    onClose()
    onLogout()
  }

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          border: '1px solid #e0e0e0',
        },
      }}
    >
      <DialogContent sx={{ p: 4 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            textAlign: 'center',
          }}
        >
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              backgroundColor: '#fff3cd',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 1,
            }}
          >
            <Typography sx={{ fontSize: '24px' }}>⚠️</Typography>
          </Box>

          <Typography
            variant="h5"
            sx={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1C3045',
              mb: 1,
            }}
          >
            Account Linking Failed
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontSize: '16px',
              color: '#4a5568',
              lineHeight: 1.6,
              mb: 1,
            }}
          >
            {errorMessage || 'Sorry, something went wrong. Please try again.'}
          </Typography>

          <Typography
            variant="body2"
            sx={{
              fontSize: '14px',
              color: '#718096',
              lineHeight: 1.5,
              mb: 1,
            }}
          >
            You are currently logged in as: <strong>{userEmail}</strong>
          </Typography>

          <Typography
            variant="body2"
            sx={{
              fontSize: '14px',
              color: '#718096',
              lineHeight: 1.5,
              fontStyle: 'italic',
              mb: 2,
            }}
          >
            To try linking accounts again, please log out and log in with the
            account you want to link from.
          </Typography>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2,
              mt: 1,
            }}
          >
            <Button
              variant="contained"
              disableRipple
              onClick={handleLogout}
              sx={{
                backgroundColor: '#1C3045',
                '&:hover': {
                  backgroundColor: '#2d4a5f',
                },
                borderRadius: 2,
                width: '150px',
                textTransform: 'none',
                fontSize: '18px',
              }}
            >
              Logout
            </Button>
            <Button
              onClick={onClose}
              variant="text"
              disableRipple
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                color: 'primary.main',
                borderColor: '#1C3045',
                '&:focus': {
                  backgroundColor: '#e8e8e8',
                },
              }}
            >
              Close and Continue on this account
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
